// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./splash_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deep Space Theme Background with generated background image */
.splash-root-v2 {
  min-height: 100vh;
  width: 100%;
  background-color: #01050e; /* Deep navy space fallback */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Custom generated background image */
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  box-sizing: border-box;
  overflow-y: auto;
  padding-top: 80px; /* Offset for the fixed header */
  padding-bottom: 24px;
}

/* Constellation grid overlays */
.space-overlay {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(white, rgba(255,255,255,.2) 2px, transparent 40px),
                    radial-gradient(white, rgba(255,255,255,.15) 1px, transparent 30px);
  background-size: 500px 500px, 300px 300px;
  background-position: 0 0, 40px 60px;
  opacity: 0.08;
  pointer-events: none;
  z-index: 1;
}

/* HEADER STYLING */
.sp-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 40px;
  background: rgba(1, 5, 14, 0.75);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  flex-shrink: 0;
  z-index: 100;
}

.sp-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.sp-logo:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.sp-logo-img {
  height: clamp(42px, 3.2vw, 56px);
  width: auto;
  object-fit: contain;
  display: block;
}

.sp-logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.sp-logo-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.sp-logo-tagline {
  font-size: 8px;
  color: #5AAF9A;
  letter-spacing: 2px;
  font-weight: 500;
}

/* Nav links with custom unified indicator */
.sp-nav {
  display: flex;
  gap: 36px;
  align-items: center;
}

.sp-nav-link {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1.5px;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.7);
}

.sp-nav-link:hover,
.sp-nav-link.active-link {
  color: #5AAF9A;
}

.sp-nav-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2.5px;
  background: #5AAF9A;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(90, 175, 154, 0.8);
  opacity: 0;
  transform: scaleX(0);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.sp-nav-link:hover::after,
.sp-nav-link.active-link::after {
  opacity: 1;
  transform: scaleX(1);
}

/* Header Actions */
.sp-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sp-btn-get {
  background: linear-gradient(90deg, #5AAF9A 0%, #307062 100%);
  border: none;
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(90, 175, 154, 0.35);
  transition: all 0.2s ease;
}

.sp-btn-get:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(90, 175, 154, 0.55);
}

.sp-btn-login {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sp-btn-login:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: white;
}

/* HERO TITLE SECTION */
.sp-hero-title {
  text-align: center;
  padding: 16px 20px 6px;
  max-width: 100%;
  margin: 0 auto;
  flex-shrink: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sp-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.1);
  border: 1px solid rgba(90, 175, 154, 0.25);
  margin-bottom: 8px;
  text-transform: uppercase;
}

/* Glassmorphic Floating Capsule */
.sp-hero-capsule {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 12px 36px 10px;
  background: linear-gradient(180deg, rgba(6, 18, 30, 0.82) 0%, rgba(2, 9, 16, 0.92) 100%);
  backdrop-filter: blur(20px) saturate(190%);
  -webkit-backdrop-filter: blur(20px) saturate(190%);
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-top: 1px solid rgba(255, 255, 255, 0.32);
  box-shadow: 
    0 12px 35px -5px rgba(0, 0, 0, 0.75),
    0 0 30px rgba(0, 240, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.sp-hero-capsule:hover {
  border-color: rgba(255, 255, 255, 0.28);
  box-shadow: 
    0 16px 45px -5px rgba(0, 0, 0, 0.85),
    0 0 40px rgba(0, 240, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.sp-hero-heading {
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 3.5px;
  line-height: 1.25;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: center;
  text-transform: uppercase;
}

.sp-pillar {
  position: relative;
  font-weight: 900;
  letter-spacing: 3px;
  transition: all 0.25s ease;
}

.sp-pillar-amalgamate {
  background: linear-gradient(135deg, #ffffff 15%, #5eead4 60%, #14b8a6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 14px rgba(45, 212, 191, 0.45));
}

.sp-pillar-educate {
  background: linear-gradient(135deg, #ffffff 15%, #c084fc 60%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 14px rgba(192, 132, 252, 0.45));
}

.sp-pillar-facilitate {
  background: linear-gradient(135deg, #ffffff 15%, #4ade80 60%, #16a34a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 14px rgba(74, 222, 128, 0.45));
}

.sp-pillar-dot {
  color: rgba(255, 255, 255, 0.35);
  font-size: 18px;
  font-weight: 800;
  -webkit-user-select: none;
          user-select: none;
}

.sp-hero-subheading {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.sp-sub-item {
  letter-spacing: 0.8px;
}

.sp-sub-amalgamate {
  color: rgba(204, 251, 241, 0.92);
  text-shadow: 0 0 12px rgba(45, 212, 191, 0.3);
}

.sp-sub-educate {
  color: rgba(243, 232, 255, 0.92);
  text-shadow: 0 0 12px rgba(192, 132, 252, 0.3);
}

.sp-sub-facilitate {
  color: rgba(220, 252, 231, 0.92);
  text-shadow: 0 0 12px rgba(74, 222, 128, 0.3);
}

.sp-sub-dot {
  color: rgba(255, 255, 255, 0.3);
  font-size: 10px;
  -webkit-user-select: none;
          user-select: none;
}

/* CARDS CONTAINER */
.sp-cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 8px 24px 24px;
  box-sizing: border-box;
  z-index: 2;
  align-items: stretch;
}

/* BASE GLOW CARD STYLE */
.sp-glow-card {
  background: linear-gradient(180deg, rgba(8, 20, 32, 0.72) 0%, rgba(3, 10, 18, 0.88) 100%);
  backdrop-filter: blur(24px) saturate(200%);
  -webkit-backdrop-filter: blur(24px) saturate(200%);
  border-radius: 24px;
  padding: 24px 20px 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
  overflow: hidden;
}

/* Hover glow states */
.sp-glow-card:hover {
  transform: translateY(-8px);
}

.card-amalgamate {
  border: 1.5px solid rgba(90, 175, 154, 0.35);
  border-top: 2.5px solid #5AAF9A;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(90, 175, 154, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.card-amalgamate:hover {
  border-color: rgba(90, 175, 154, 0.85);
  box-shadow: 0 20px 50px rgba(90, 175, 154, 0.25), inset 0 0 25px rgba(90, 175, 154, 0.1);
}

.card-adventure {
  border: 1.5px solid rgba(90, 175, 154, 0.35);
  border-top: 2.5px solid #5AAF9A;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(90, 175, 154, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.card-adventure:hover {
  border-color: rgba(90, 175, 154, 0.85);
  box-shadow: 0 20px 50px rgba(90, 175, 154, 0.25), inset 0 0 25px rgba(90, 175, 154, 0.1);
}

.card-gear {
  border: 1.5px solid rgba(45, 170, 110, 0.35);
  border-top: 2.5px solid #2DAA6E;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(45, 170, 110, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.card-gear:hover {
  border-color: rgba(45, 170, 110, 0.85);
  box-shadow: 0 20px 50px rgba(45, 170, 110, 0.25), inset 0 0 25px rgba(45, 170, 110, 0.1);
}

/* CARD STEP BADGE */
.card-step-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.1);
  border: 1px solid rgba(90, 175, 154, 0.25);
  margin-bottom: 10px;
  text-transform: uppercase;
}

.card-gear .card-step-badge {
  color: #2DAA6E;
  background: rgba(45, 170, 110, 0.1);
  border-color: rgba(45, 170, 110, 0.25);
}

/* CARD BRAND BLOCK */
.card-header-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 12px;
  width: 100%;
}

.card-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
  width: 100%;
}

.card-logo-img {
  height: 30px;
  width: auto;
}

.card-logo-icon {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
}

.card-logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
}

.card-logo-title {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #ffffff;
}

.card-logo-title.green-title {
  color: #5AAF9A;
  text-shadow: 0 0 10px rgba(90, 175, 154, 0.3);
}

.card-gear .card-logo-title.green-title {
  color: #2DAA6E;
  text-shadow: 0 0 10px rgba(45, 170, 110, 0.3);
}

.card-desc {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  margin: 0;
  min-height: 36px;
}

/* Card Body Split: features list & phone mockup */
.card-body-split {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  gap: 14px;
  margin-bottom: 0;
  min-height: 318px;
}

.card-left-column {
  flex: 1.18 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0;
  position: relative;
  z-index: 2;
}

/* FEATURES LIST STYLING */
.card-features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 10px;
}

.card-features-list li {
  display: flex;
  gap: 9px;
  align-items: flex-start;
}

.feat-icon-badge {
  width: 27px;
  height: 27px;
  border-radius: 7px;
  background: rgba(90, 175, 154, 0.09);
  border: 1px solid rgba(90, 175, 154, 0.22);
  color: #5AAF9A;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  transition: all 0.25s ease;
}

.card-gear .feat-icon-badge {
  background: rgba(45, 170, 110, 0.09);
  border-color: rgba(45, 170, 110, 0.22);
  color: #2DAA6E;
}

.card-features-list li:hover .feat-icon-badge {
  background: rgba(90, 175, 154, 0.22);
  transform: scale(1.08);
  box-shadow: 0 0 10px rgba(90, 175, 154, 0.35);
}

.card-features-list li div {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.feat-title-row {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 6px !important;
  flex-wrap: nowrap;
}

.coming-soon-pill {
  display: inline-flex !important;
  align-items: center;
  padding: 1.5px 6px;
  border-radius: 6px;
  font-size: 7.5px !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #5AAF9A !important;
  background: rgba(90, 175, 154, 0.14);
  border: 1px solid rgba(90, 175, 154, 0.32);
  box-shadow: 0 0 8px rgba(90, 175, 154, 0.15);
  line-height: 1.1;
  white-space: nowrap;
  margin-top: 0 !important;
}

.card-gear .coming-soon-pill {
  color: #2DAA6E !important;
  background: rgba(45, 170, 110, 0.14);
  border-color: rgba(45, 170, 110, 0.32);
  box-shadow: 0 0 8px rgba(45, 170, 110, 0.15);
}

.feat-item-upcoming {
  opacity: 0.88;
  transition: opacity 0.25s ease;
}

.feat-item-upcoming:hover {
  opacity: 1;
}

.card-features-list li div strong {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
}

.card-features-list li div span:not(.coming-soon-pill) {
  font-size: 9.5px;
  color: rgba(255, 255, 255, 0.52);
  margin-top: 1px;
  line-height: 1.25;
}

/* HIGH FIDELITY PHONE MOCKUP */
.phone-mockup-wrapper {
  flex: 0.95 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 3;
}

.phone-mockup {
  width: 100%;
  max-width: 172px;
  height: 318px;
  background-color: #03080d;
  border: 2.2px solid rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  position: relative;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.7), inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.card-amalgamate .phone-mockup {
  transform: perspective(600px) rotateY(-3deg);
}
.card-adventure .phone-mockup {
  transform: perspective(600px) rotateY(0deg);
}
.card-gear .phone-mockup {
  transform: perspective(600px) rotateY(3deg);
}

.sp-glow-card:hover .phone-mockup {
  transform: perspective(600px) rotateY(0deg) scale(1.02);
  border-color: rgba(90, 175, 154, 0.5);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.8), 0 0 20px rgba(90, 175, 154, 0.2);
}

.phone-dynamic-island {
  width: 42px;
  height: 8.5px;
  background: #000;
  border-radius: 6px;
  margin: 4px auto 2px;
  flex-shrink: 0;
}

.phone-screen {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3px 7px 7px;
  box-sizing: border-box;
  font-size: 8.5px;
  overflow: hidden;
  background-color: #02070c;
  gap: 4px;
}

.phone-status-bar {
  display: flex;
  justify-content: space-between;
  font-size: 7.2px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 2px;
  padding: 0 2px;
  flex-shrink: 0;
}

.phone-app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
  flex-shrink: 0;
}

.phone-header-brand {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  font-size: 9.2px;
  color: #fff;
}

.mini-logo {
  height: 10.5px;
  width: auto;
}

.phone-badge-pulse {
  font-size: 6px;
  color: #5AAF9A;
  font-weight: 700;
  background: rgba(90, 175, 154, 0.15);
  border: 1px solid rgba(90, 175, 154, 0.3);
  border-radius: 4px;
  padding: 2px 4.5px;
  text-transform: uppercase;
}

.phone-badge-verified {
  font-size: 6px;
  color: #5AAF9A;
  font-weight: 700;
  background: rgba(90, 175, 154, 0.15);
  border: 1px solid rgba(90, 175, 154, 0.3);
  border-radius: 4px;
  padding: 2px 4.5px;
}

.phone-badge-escrow {
  font-size: 6px;
  color: #2DAA6E;
  font-weight: 700;
  background: rgba(45, 170, 110, 0.15);
  border: 1px solid rgba(45, 170, 110, 0.3);
  border-radius: 4px;
  padding: 2px 4.5px;
}

/* Card 1: Phone Ballot Preview */
.phone-ballot-preview {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(90, 175, 154, 0.22);
  border-radius: 7px;
  padding: 5px 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 2px;
}

.phone-ballot-tag {
  font-size: 5.5px;
  color: #5AAF9A;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.phone-ballot-preview h5 {
  font-size: 7.5px;
  font-weight: 700;
  line-height: 1.22;
  color: #ffffff;
  margin: 2px 0;
}

.phone-vote-track {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
  margin: 2px 0 1.5px;
}

.phone-vote-bar {
  height: 100%;
  background: linear-gradient(90deg, #3DA58A, #5AAF9A);
  border-radius: 2px;
}

.phone-vote-stats {
  display: flex;
  justify-content: space-between;
  font-size: 6.2px;
}

.vote-pct {
  color: #5AAF9A;
  font-weight: 700;
}

.vote-cnt {
  color: rgba(255, 255, 255, 0.5);
}

.phone-btn-vote {
  background: linear-gradient(90deg, #3DA58A, #5AAF9A);
  border: none;
  border-radius: 4px;
  color: white;
  width: 100%;
  padding: 3.5px 0;
  font-size: 6.8px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 2.5px;
}

/* Phone Live Pulse Widget */
.phone-pulse-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(90, 175, 154, 0.15);
  border-radius: 5px;
  padding: 3.5px 5px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 2px;
}

.phone-pulse-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 6px;
  color: rgba(255, 255, 255, 0.75);
}

.phone-pulse-row strong {
  font-size: 6px;
  color: rgba(255, 255, 255, 0.95);
}

.pulse-tag-green {
  color: #5AAF9A;
  font-weight: 700;
}

.phone-list-pills {
  display: flex;
  gap: 3px;
  justify-content: space-between;
  margin-bottom: 2px;
}

.phone-list-pills span {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 2px 3px;
  border-radius: 3px;
  font-size: 5.8px;
  color: rgba(255, 255, 255, 0.75);
  flex: 1 1;
  text-align: center;
}

.phone-amalgamate-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5.8px;
  font-weight: 700;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.08);
  border: 1px solid rgba(90, 175, 154, 0.18);
  border-radius: 3.5px;
  padding: 2.5px 0;
}

/* Card 2: Educate Phone UI */
.phone-educate-hero {
  background: linear-gradient(135deg, rgba(90, 175, 154, 0.16) 0%, rgba(45, 170, 110, 0.06) 100%);
  border: 1px solid rgba(90, 175, 154, 0.25);
  border-radius: 6px;
  padding: 3.5px 5px;
  margin-bottom: 3px;
  text-align: center;
  flex-shrink: 0;
}

.phone-cert-eyebrow {
  font-size: 5.5px;
  color: #5AAF9A;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.6px;
  display: block;
}

.phone-cert-title {
  margin: 1px 0 0;
  font-size: 7px;
  font-weight: 700;
  line-height: 1.15;
  color: #ffffff;
}

.phone-tenets-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2.5px;
  margin-bottom: 3px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.phone-tenets-container::-webkit-scrollbar { display: none; }

.phone-tenet-item {
  display: flex;
  align-items: flex-start;
  gap: 3.5px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(90, 175, 154, 0.13);
  border-radius: 4px;
  padding: 2.5px 3.5px;
}

.phone-tenet-num {
  background: rgba(90, 175, 154, 0.2);
  color: #5AAF9A;
  font-size: 5.5px;
  font-weight: 700;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}

.phone-tenet-item div {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.phone-tenet-item strong {
  font-size: 6.6px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
}

.phone-tenet-item span {
  font-size: 5.5px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 0.5px;
  line-height: 1.18;
  word-break: break-word;
}

.phone-cert-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5.8px;
  font-weight: 700;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.08);
  border: 1px solid rgba(90, 175, 154, 0.18);
  border-radius: 3.5px;
  padding: 2.5px 0;
}

/* Card 3: Gear Phone UI details */
.phone-cause-header {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(45, 170, 110, 0.2);
  border-radius: 6px;
  padding: 4px 6px;
  margin-bottom: 3px;
  text-align: center;
  flex-shrink: 0;
}

.phone-cause-label {
  font-size: 5.5px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: rgba(255, 255, 255, 0.45);
  display: block;
}

.phone-cause-name {
  font-size: 7.8px;
  font-weight: 800;
  color: #2DAA6E;
  margin: 1px 0;
}

.phone-cause-total {
  font-size: 10px;
  font-weight: 800;
  color: #fff;
}

.phone-bc-chart {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  padding: 4px 5.5px;
  display: flex;
  flex-direction: column;
  gap: 2.5px;
  margin-bottom: 3px;
}

.phone-bc-hdr {
  display: flex;
  justify-content: space-between;
  font-size: 5.5px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 2px;
}

.phone-bc-row {
  display: flex;
  flex-direction: column;
  gap: 1.5px;
}

.phone-bc-info {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.phone-bc-city {
  font-size: 6.6px;
  font-weight: 600;
  color: #fff;
}

.phone-bc-val {
  font-size: 6.6px;
  font-weight: 700;
  color: #2DAA6E;
}

.phone-bc-bar-bg {
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
}

.phone-bc-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #1E9E64 0%, #2DAA6E 100%);
  border-radius: 2px;
}

.phone-escrow-meta {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5.6px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.65);
  padding: 1.5px 0;
  margin-bottom: 2px;
}

.phone-bc-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5.8px;
  font-weight: 700;
  color: #2DAA6E;
  background: rgba(45, 170, 110, 0.08);
  border: 1px solid rgba(45, 170, 110, 0.18);
  border-radius: 3.5px;
  padding: 2.5px 0;
}

/* CARD ACTION BUTTONS with rich gradient glow */
.card-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  padding: 12.5px 20px;
  border-radius: 28px;
  color: white;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
  flex-shrink: 0;
  margin-top: 0;
}

.card-action-btn span {
  transition: transform 0.2s ease;
}

.card-action-btn:hover span {
  transform: translateX(4px);
}

.btn-amalgamate {
  background: linear-gradient(90deg, #3A907C 0%, #5AAF9A 100%);
  box-shadow: 0 4px 18px rgba(90, 175, 154, 0.35);
}
.btn-amalgamate:hover {
  box-shadow: 0 6px 25px rgba(90, 175, 154, 0.55);
  filter: brightness(1.15);
}

.btn-adventure {
  background: linear-gradient(90deg, #2DAA6E 0%, #5AAF9A 100%);
  box-shadow: 0 4px 18px rgba(45, 170, 110, 0.35);
}
.btn-adventure:hover {
  box-shadow: 0 6px 25px rgba(45, 170, 110, 0.55);
  filter: brightness(1.15);
}

.btn-gear {
  background: linear-gradient(90deg, #1E9E64 0%, #2DAA6E 100%);
  box-shadow: 0 4px 18px rgba(45, 170, 110, 0.35);
}
.btn-gear:hover {
  box-shadow: 0 6px 25px rgba(45, 170, 110, 0.55);
  filter: brightness(1.15);
}

/* FOOTER NAVIGATION CARD COMPONENT */
.sp-footer-v2 {
  margin: 20px 40px 0;
  background: linear-gradient(180deg, rgba(6, 18, 30, 0.75) 0%, rgba(2, 9, 16, 0.88) 100%) !important;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.24) !important;
  border-radius: 20px;
  padding: 12px 28px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.65), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  z-index: 10;
  transition: all 0.3s ease;
}

.sp-footer-hdr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.sp-footer-tag {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2.5px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
}

.sp-footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.sp-footer-plain-text {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  cursor: default;
  letter-spacing: 0.2px;
  -webkit-user-select: none;
          user-select: none;
}

.sp-footer-legal-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 20%, rgba(255, 255, 255, 0.12) 80%, transparent 100%);
  margin: 6px 0 2px;
}

.sp-footer-legal-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 4px 6px 2px;
}

.sp-footer-copyright {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.2px;
}

.sp-footer-legal-links {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.sp-legal-link {
  font-size: 11.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.65);
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.2px;
}

.sp-legal-link:hover {
  color: #5eead4;
  text-shadow: 0 0 8px rgba(94, 234, 212, 0.5);
}

.sp-legal-separator {
  color: rgba(255, 255, 255, 0.25);
  font-size: 8px;
}

/* RESPONSIVE SCALING */
@media (max-width: 1200px) {
  .sp-cards-container {
    grid-template-columns: repeat(2, 1fr);
    padding: 10px 24px 20px;
  }
  .sp-footer-v2 {
    margin: 20px 24px 0;
  }
}

@media (max-width: 768px) {
  .sp-header {
    padding: 12px 20px;
  }
  .sp-nav {
    display: none;
  }
  .sp-hero-title {
    padding: 20px 16px 10px;
  }
  .sp-hero-capsule {
    border-radius: 20px;
    padding: 10px 20px 8px;
    gap: 4px;
  }
  .sp-hero-heading {
    font-size: 15px;
    letter-spacing: 1.5px;
    gap: 8px;
  }
  .sp-pillar {
    letter-spacing: 1.5px;
  }
  .sp-hero-subheading {
    font-size: 10.5px;
    gap: 6px;
    letter-spacing: 0.5px;
  }
  .sp-cards-container {
    grid-template-columns: 1fr;
    padding: 10px 20px 20px;
    gap: 20px;
  }
  .sp-glow-card {
    padding: 20px;
  }
  .sp-footer-v2 {
    margin: 15px 20px 0;
    padding: 12px 16px;
  }
  .sp-footer-links {
    gap: 15px 20px;
  }
}

@media (max-width: 520px) {
  .card-body-split {
    flex-direction: column;
    align-items: center;
  }
  .card-left-column {
    width: 100%;
  }
  .phone-mockup-wrapper {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    margin-top: 16px;
  }
  .phone-mockup {
    transform: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/SplashPage/SplashPage.css"],"names":[],"mappings":"AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB,EAAE,6BAA6B;EACxD,yDAAwC,EAAE,sCAAsC;EAChF,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB,EAAE,gCAAgC;EACnD,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR;uFACqF;EACrF,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;EACV,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,cAAc;EACd,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,wFAAwF;EACxF,0CAA0C;EAC1C,kDAAkD;EAClD,qBAAqB;EACrB,2CAA2C;EAC3C,+CAA+C;EAC/C;;;2CAGyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC;;;2CAGyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,yFAAyF;EACzF,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,sHAAsH;AACxH;AACA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,sHAAsH;AACxH;AACA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,sHAAsH;AACxH;AACA;EACE,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,MAAM;EACN,kBAAkB;EAClB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,0CAA0C;EAC1C,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,YAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,qFAAqF;EACrF,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uDAAuD;EACvD,qCAAqC;EACrC,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,+FAA+F;EAC/F,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,6CAA6C,aAAa,EAAE;;AAE5D;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,sCAAsC;EACtC,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kDAAkD;EAClD,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4DAA4D;EAC5D,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,4DAA4D;EAC5D,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,4DAA4D;EAC5D,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,mGAAmG;EACnG,0CAA0C;EAC1C,kDAAkD;EAClD,sDAAsD;EACtD,0DAA0D;EAC1D,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mFAAmF;EACnF,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kIAAkI;EAClI,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,eAAe;IACf,qBAAqB;IACrB,QAAQ;EACV;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,QAAQ;IACR,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n/* Deep Space Theme Background with generated background image */\n.splash-root-v2 {\n  min-height: 100vh;\n  width: 100%;\n  background-color: #01050e; /* Deep navy space fallback */\n  background-image: url('./splash_bg.png'); /* Custom generated background image */\n  background-size: cover;\n  background-position: center bottom;\n  background-repeat: no-repeat;\n  color: #ffffff;\n  font-family: 'Inter', sans-serif;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 12px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  padding-top: 80px; /* Offset for the fixed header */\n  padding-bottom: 24px;\n}\n\n/* Constellation grid overlays */\n.space-overlay {\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(white, rgba(255,255,255,.2) 2px, transparent 40px),\n                    radial-gradient(white, rgba(255,255,255,.15) 1px, transparent 30px);\n  background-size: 500px 500px, 300px 300px;\n  background-position: 0 0, 40px 60px;\n  opacity: 0.08;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* HEADER STYLING */\n.sp-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 40px;\n  background: rgba(1, 5, 14, 0.75);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  flex-shrink: 0;\n  z-index: 100;\n}\n\n.sp-logo {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.sp-logo:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.sp-logo-img {\n  height: clamp(42px, 3.2vw, 56px);\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.sp-logo-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n}\n\n.sp-logo-title {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.sp-logo-tagline {\n  font-size: 8px;\n  color: #5AAF9A;\n  letter-spacing: 2px;\n  font-weight: 500;\n}\n\n/* Nav links with custom unified indicator */\n.sp-nav {\n  display: flex;\n  gap: 36px;\n  align-items: center;\n}\n\n.sp-nav-link {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  cursor: pointer;\n  padding: 8px 0;\n  position: relative;\n  transition: all 0.3s ease;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.sp-nav-link:hover,\n.sp-nav-link.active-link {\n  color: #5AAF9A;\n}\n\n.sp-nav-link::after {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2.5px;\n  background: #5AAF9A;\n  border-radius: 2px;\n  box-shadow: 0 0 10px rgba(90, 175, 154, 0.8);\n  opacity: 0;\n  transform: scaleX(0);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.sp-nav-link:hover::after,\n.sp-nav-link.active-link::after {\n  opacity: 1;\n  transform: scaleX(1);\n}\n\n/* Header Actions */\n.sp-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.sp-btn-get {\n  background: linear-gradient(90deg, #5AAF9A 0%, #307062 100%);\n  border: none;\n  color: white;\n  padding: 8px 20px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(90, 175, 154, 0.35);\n  transition: all 0.2s ease;\n}\n\n.sp-btn-get:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(90, 175, 154, 0.55);\n}\n\n.sp-btn-login {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 8px 20px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sp-btn-login:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: white;\n}\n\n/* HERO TITLE SECTION */\n.sp-hero-title {\n  text-align: center;\n  padding: 16px 20px 6px;\n  max-width: 100%;\n  margin: 0 auto;\n  flex-shrink: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sp-hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.1);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n/* Glassmorphic Floating Capsule */\n.sp-hero-capsule {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 12px 36px 10px;\n  background: linear-gradient(180deg, rgba(6, 18, 30, 0.82) 0%, rgba(2, 9, 16, 0.92) 100%);\n  backdrop-filter: blur(20px) saturate(190%);\n  -webkit-backdrop-filter: blur(20px) saturate(190%);\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-top: 1px solid rgba(255, 255, 255, 0.32);\n  box-shadow: \n    0 12px 35px -5px rgba(0, 0, 0, 0.75),\n    0 0 30px rgba(0, 240, 255, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.sp-hero-capsule:hover {\n  border-color: rgba(255, 255, 255, 0.28);\n  box-shadow: \n    0 16px 45px -5px rgba(0, 0, 0, 0.85),\n    0 0 40px rgba(0, 240, 255, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.sp-hero-heading {\n  font-size: 22px;\n  font-weight: 900;\n  letter-spacing: 3.5px;\n  line-height: 1.25;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  justify-content: center;\n  text-transform: uppercase;\n}\n\n.sp-pillar {\n  position: relative;\n  font-weight: 900;\n  letter-spacing: 3px;\n  transition: all 0.25s ease;\n}\n\n.sp-pillar-amalgamate {\n  background: linear-gradient(135deg, #ffffff 15%, #5eead4 60%, #14b8a6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  filter: drop-shadow(0 0 14px rgba(45, 212, 191, 0.45));\n}\n\n.sp-pillar-educate {\n  background: linear-gradient(135deg, #ffffff 15%, #c084fc 60%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  filter: drop-shadow(0 0 14px rgba(192, 132, 252, 0.45));\n}\n\n.sp-pillar-facilitate {\n  background: linear-gradient(135deg, #ffffff 15%, #4ade80 60%, #16a34a 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  filter: drop-shadow(0 0 14px rgba(74, 222, 128, 0.45));\n}\n\n.sp-pillar-dot {\n  color: rgba(255, 255, 255, 0.35);\n  font-size: 18px;\n  font-weight: 800;\n  user-select: none;\n}\n\n.sp-hero-subheading {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.sp-sub-item {\n  letter-spacing: 0.8px;\n}\n\n.sp-sub-amalgamate {\n  color: rgba(204, 251, 241, 0.92);\n  text-shadow: 0 0 12px rgba(45, 212, 191, 0.3);\n}\n\n.sp-sub-educate {\n  color: rgba(243, 232, 255, 0.92);\n  text-shadow: 0 0 12px rgba(192, 132, 252, 0.3);\n}\n\n.sp-sub-facilitate {\n  color: rgba(220, 252, 231, 0.92);\n  text-shadow: 0 0 12px rgba(74, 222, 128, 0.3);\n}\n\n.sp-sub-dot {\n  color: rgba(255, 255, 255, 0.3);\n  font-size: 10px;\n  user-select: none;\n}\n\n/* CARDS CONTAINER */\n.sp-cards-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n  max-width: 1440px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 8px 24px 24px;\n  box-sizing: border-box;\n  z-index: 2;\n  align-items: stretch;\n}\n\n/* BASE GLOW CARD STYLE */\n.sp-glow-card {\n  background: linear-gradient(180deg, rgba(8, 20, 32, 0.72) 0%, rgba(3, 10, 18, 0.88) 100%);\n  backdrop-filter: blur(24px) saturate(200%);\n  -webkit-backdrop-filter: blur(24px) saturate(200%);\n  border-radius: 24px;\n  padding: 24px 20px 22px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 16px;\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Hover glow states */\n.sp-glow-card:hover {\n  transform: translateY(-8px);\n}\n\n.card-amalgamate {\n  border: 1.5px solid rgba(90, 175, 154, 0.35);\n  border-top: 2.5px solid #5AAF9A;\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(90, 175, 154, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);\n}\n.card-amalgamate:hover {\n  border-color: rgba(90, 175, 154, 0.85);\n  box-shadow: 0 20px 50px rgba(90, 175, 154, 0.25), inset 0 0 25px rgba(90, 175, 154, 0.1);\n}\n\n.card-adventure {\n  border: 1.5px solid rgba(90, 175, 154, 0.35);\n  border-top: 2.5px solid #5AAF9A;\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(90, 175, 154, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);\n}\n.card-adventure:hover {\n  border-color: rgba(90, 175, 154, 0.85);\n  box-shadow: 0 20px 50px rgba(90, 175, 154, 0.25), inset 0 0 25px rgba(90, 175, 154, 0.1);\n}\n\n.card-gear {\n  border: 1.5px solid rgba(45, 170, 110, 0.35);\n  border-top: 2.5px solid #2DAA6E;\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5), 0 0 35px rgba(45, 170, 110, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.15);\n}\n.card-gear:hover {\n  border-color: rgba(45, 170, 110, 0.85);\n  box-shadow: 0 20px 50px rgba(45, 170, 110, 0.25), inset 0 0 25px rgba(45, 170, 110, 0.1);\n}\n\n/* CARD STEP BADGE */\n.card-step-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 9px;\n  border-radius: 20px;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.1);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n\n.card-gear .card-step-badge {\n  color: #2DAA6E;\n  background: rgba(45, 170, 110, 0.1);\n  border-color: rgba(45, 170, 110, 0.25);\n}\n\n/* CARD BRAND BLOCK */\n.card-header-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 12px;\n  width: 100%;\n}\n\n.card-brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.card-logo-img {\n  height: 30px;\n  width: auto;\n}\n\n.card-logo-icon {\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30px;\n  width: 30px;\n}\n\n.card-logo-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  text-align: left;\n}\n\n.card-logo-title {\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n}\n\n.card-logo-title.green-title {\n  color: #5AAF9A;\n  text-shadow: 0 0 10px rgba(90, 175, 154, 0.3);\n}\n\n.card-gear .card-logo-title.green-title {\n  color: #2DAA6E;\n  text-shadow: 0 0 10px rgba(45, 170, 110, 0.3);\n}\n\n.card-desc {\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.5;\n  margin: 0;\n  min-height: 36px;\n}\n\n/* Card Body Split: features list & phone mockup */\n.card-body-split {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: 14px;\n  margin-bottom: 0;\n  min-height: 318px;\n}\n\n.card-left-column {\n  flex: 1.18;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0;\n  position: relative;\n  z-index: 2;\n}\n\n/* FEATURES LIST STYLING */\n.card-features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  gap: 10px;\n}\n\n.card-features-list li {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n}\n\n.feat-icon-badge {\n  width: 27px;\n  height: 27px;\n  border-radius: 7px;\n  background: rgba(90, 175, 154, 0.09);\n  border: 1px solid rgba(90, 175, 154, 0.22);\n  color: #5AAF9A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n  transition: all 0.25s ease;\n}\n\n.card-gear .feat-icon-badge {\n  background: rgba(45, 170, 110, 0.09);\n  border-color: rgba(45, 170, 110, 0.22);\n  color: #2DAA6E;\n}\n\n.card-features-list li:hover .feat-icon-badge {\n  background: rgba(90, 175, 154, 0.22);\n  transform: scale(1.08);\n  box-shadow: 0 0 10px rgba(90, 175, 154, 0.35);\n}\n\n.card-features-list li div {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n}\n\n.feat-title-row {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-wrap: nowrap;\n}\n\n.coming-soon-pill {\n  display: inline-flex !important;\n  align-items: center;\n  padding: 1.5px 6px;\n  border-radius: 6px;\n  font-size: 7.5px !important;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #5AAF9A !important;\n  background: rgba(90, 175, 154, 0.14);\n  border: 1px solid rgba(90, 175, 154, 0.32);\n  box-shadow: 0 0 8px rgba(90, 175, 154, 0.15);\n  line-height: 1.1;\n  white-space: nowrap;\n  margin-top: 0 !important;\n}\n\n.card-gear .coming-soon-pill {\n  color: #2DAA6E !important;\n  background: rgba(45, 170, 110, 0.14);\n  border-color: rgba(45, 170, 110, 0.32);\n  box-shadow: 0 0 8px rgba(45, 170, 110, 0.15);\n}\n\n.feat-item-upcoming {\n  opacity: 0.88;\n  transition: opacity 0.25s ease;\n}\n\n.feat-item-upcoming:hover {\n  opacity: 1;\n}\n\n.card-features-list li div strong {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.card-features-list li div span:not(.coming-soon-pill) {\n  font-size: 9.5px;\n  color: rgba(255, 255, 255, 0.52);\n  margin-top: 1px;\n  line-height: 1.25;\n}\n\n/* HIGH FIDELITY PHONE MOCKUP */\n.phone-mockup-wrapper {\n  flex: 0.95;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 3;\n}\n\n.phone-mockup {\n  width: 100%;\n  max-width: 172px;\n  height: 318px;\n  background-color: #03080d;\n  border: 2.2px solid rgba(255, 255, 255, 0.16);\n  border-radius: 20px;\n  position: relative;\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.7), inset 0 0 0 1px rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.card-amalgamate .phone-mockup {\n  transform: perspective(600px) rotateY(-3deg);\n}\n.card-adventure .phone-mockup {\n  transform: perspective(600px) rotateY(0deg);\n}\n.card-gear .phone-mockup {\n  transform: perspective(600px) rotateY(3deg);\n}\n\n.sp-glow-card:hover .phone-mockup {\n  transform: perspective(600px) rotateY(0deg) scale(1.02);\n  border-color: rgba(90, 175, 154, 0.5);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.8), 0 0 20px rgba(90, 175, 154, 0.2);\n}\n\n.phone-dynamic-island {\n  width: 42px;\n  height: 8.5px;\n  background: #000;\n  border-radius: 6px;\n  margin: 4px auto 2px;\n  flex-shrink: 0;\n}\n\n.phone-screen {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 3px 7px 7px;\n  box-sizing: border-box;\n  font-size: 8.5px;\n  overflow: hidden;\n  background-color: #02070c;\n  gap: 4px;\n}\n\n.phone-status-bar {\n  display: flex;\n  justify-content: space-between;\n  font-size: 7.2px;\n  color: rgba(255, 255, 255, 0.55);\n  margin-bottom: 2px;\n  padding: 0 2px;\n  flex-shrink: 0;\n}\n\n.phone-app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 3px;\n  flex-shrink: 0;\n}\n\n.phone-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-weight: 700;\n  font-size: 9.2px;\n  color: #fff;\n}\n\n.mini-logo {\n  height: 10.5px;\n  width: auto;\n}\n\n.phone-badge-pulse {\n  font-size: 6px;\n  color: #5AAF9A;\n  font-weight: 700;\n  background: rgba(90, 175, 154, 0.15);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  border-radius: 4px;\n  padding: 2px 4.5px;\n  text-transform: uppercase;\n}\n\n.phone-badge-verified {\n  font-size: 6px;\n  color: #5AAF9A;\n  font-weight: 700;\n  background: rgba(90, 175, 154, 0.15);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  border-radius: 4px;\n  padding: 2px 4.5px;\n}\n\n.phone-badge-escrow {\n  font-size: 6px;\n  color: #2DAA6E;\n  font-weight: 700;\n  background: rgba(45, 170, 110, 0.15);\n  border: 1px solid rgba(45, 170, 110, 0.3);\n  border-radius: 4px;\n  padding: 2px 4.5px;\n}\n\n/* Card 1: Phone Ballot Preview */\n.phone-ballot-preview {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(90, 175, 154, 0.22);\n  border-radius: 7px;\n  padding: 5px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 2px;\n}\n\n.phone-ballot-tag {\n  font-size: 5.5px;\n  color: #5AAF9A;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n.phone-ballot-preview h5 {\n  font-size: 7.5px;\n  font-weight: 700;\n  line-height: 1.22;\n  color: #ffffff;\n  margin: 2px 0;\n}\n\n.phone-vote-track {\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n  margin: 2px 0 1.5px;\n}\n\n.phone-vote-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #3DA58A, #5AAF9A);\n  border-radius: 2px;\n}\n\n.phone-vote-stats {\n  display: flex;\n  justify-content: space-between;\n  font-size: 6.2px;\n}\n\n.vote-pct {\n  color: #5AAF9A;\n  font-weight: 700;\n}\n\n.vote-cnt {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.phone-btn-vote {\n  background: linear-gradient(90deg, #3DA58A, #5AAF9A);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  width: 100%;\n  padding: 3.5px 0;\n  font-size: 6.8px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 2.5px;\n}\n\n/* Phone Live Pulse Widget */\n.phone-pulse-box {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(90, 175, 154, 0.15);\n  border-radius: 5px;\n  padding: 3.5px 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 2px;\n}\n\n.phone-pulse-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 6px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.phone-pulse-row strong {\n  font-size: 6px;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.pulse-tag-green {\n  color: #5AAF9A;\n  font-weight: 700;\n}\n\n.phone-list-pills {\n  display: flex;\n  gap: 3px;\n  justify-content: space-between;\n  margin-bottom: 2px;\n}\n\n.phone-list-pills span {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 2px 3px;\n  border-radius: 3px;\n  font-size: 5.8px;\n  color: rgba(255, 255, 255, 0.75);\n  flex: 1;\n  text-align: center;\n}\n\n.phone-amalgamate-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 5.8px;\n  font-weight: 700;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.08);\n  border: 1px solid rgba(90, 175, 154, 0.18);\n  border-radius: 3.5px;\n  padding: 2.5px 0;\n}\n\n/* Card 2: Educate Phone UI */\n.phone-educate-hero {\n  background: linear-gradient(135deg, rgba(90, 175, 154, 0.16) 0%, rgba(45, 170, 110, 0.06) 100%);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  border-radius: 6px;\n  padding: 3.5px 5px;\n  margin-bottom: 3px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.phone-cert-eyebrow {\n  font-size: 5.5px;\n  color: #5AAF9A;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  display: block;\n}\n\n.phone-cert-title {\n  margin: 1px 0 0;\n  font-size: 7px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #ffffff;\n}\n\n.phone-tenets-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5px;\n  margin-bottom: 3px;\n  overflow-y: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.phone-tenets-container::-webkit-scrollbar { display: none; }\n\n.phone-tenet-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 3.5px;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(90, 175, 154, 0.13);\n  border-radius: 4px;\n  padding: 2.5px 3.5px;\n}\n\n.phone-tenet-num {\n  background: rgba(90, 175, 154, 0.2);\n  color: #5AAF9A;\n  font-size: 5.5px;\n  font-weight: 700;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.phone-tenet-item div {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.15;\n}\n\n.phone-tenet-item strong {\n  font-size: 6.6px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.phone-tenet-item span {\n  font-size: 5.5px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 0.5px;\n  line-height: 1.18;\n  word-break: break-word;\n}\n\n.phone-cert-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 5.8px;\n  font-weight: 700;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.08);\n  border: 1px solid rgba(90, 175, 154, 0.18);\n  border-radius: 3.5px;\n  padding: 2.5px 0;\n}\n\n/* Card 3: Gear Phone UI details */\n.phone-cause-header {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(45, 170, 110, 0.2);\n  border-radius: 6px;\n  padding: 4px 6px;\n  margin-bottom: 3px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.phone-cause-label {\n  font-size: 5.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: rgba(255, 255, 255, 0.45);\n  display: block;\n}\n\n.phone-cause-name {\n  font-size: 7.8px;\n  font-weight: 800;\n  color: #2DAA6E;\n  margin: 1px 0;\n}\n\n.phone-cause-total {\n  font-size: 10px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.phone-bc-chart {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 6px;\n  padding: 4px 5.5px;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5px;\n  margin-bottom: 3px;\n}\n\n.phone-bc-hdr {\n  display: flex;\n  justify-content: space-between;\n  font-size: 5.5px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  padding-bottom: 2px;\n}\n\n.phone-bc-row {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5px;\n}\n\n.phone-bc-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.phone-bc-city {\n  font-size: 6.6px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.phone-bc-val {\n  font-size: 6.6px;\n  font-weight: 700;\n  color: #2DAA6E;\n}\n\n.phone-bc-bar-bg {\n  width: 100%;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.phone-bc-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #1E9E64 0%, #2DAA6E 100%);\n  border-radius: 2px;\n}\n\n.phone-escrow-meta {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 5.6px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.65);\n  padding: 1.5px 0;\n  margin-bottom: 2px;\n}\n\n.phone-bc-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 5.8px;\n  font-weight: 700;\n  color: #2DAA6E;\n  background: rgba(45, 170, 110, 0.08);\n  border: 1px solid rgba(45, 170, 110, 0.18);\n  border-radius: 3.5px;\n  padding: 2.5px 0;\n}\n\n/* CARD ACTION BUTTONS with rich gradient glow */\n.card-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  padding: 12.5px 20px;\n  border-radius: 28px;\n  color: white;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  width: 100%;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  margin-top: 0;\n}\n\n.card-action-btn span {\n  transition: transform 0.2s ease;\n}\n\n.card-action-btn:hover span {\n  transform: translateX(4px);\n}\n\n.btn-amalgamate {\n  background: linear-gradient(90deg, #3A907C 0%, #5AAF9A 100%);\n  box-shadow: 0 4px 18px rgba(90, 175, 154, 0.35);\n}\n.btn-amalgamate:hover {\n  box-shadow: 0 6px 25px rgba(90, 175, 154, 0.55);\n  filter: brightness(1.15);\n}\n\n.btn-adventure {\n  background: linear-gradient(90deg, #2DAA6E 0%, #5AAF9A 100%);\n  box-shadow: 0 4px 18px rgba(45, 170, 110, 0.35);\n}\n.btn-adventure:hover {\n  box-shadow: 0 6px 25px rgba(45, 170, 110, 0.55);\n  filter: brightness(1.15);\n}\n\n.btn-gear {\n  background: linear-gradient(90deg, #1E9E64 0%, #2DAA6E 100%);\n  box-shadow: 0 4px 18px rgba(45, 170, 110, 0.35);\n}\n.btn-gear:hover {\n  box-shadow: 0 6px 25px rgba(45, 170, 110, 0.55);\n  filter: brightness(1.15);\n}\n\n/* FOOTER NAVIGATION CARD COMPONENT */\n.sp-footer-v2 {\n  margin: 20px 40px 0;\n  background: linear-gradient(180deg, rgba(6, 18, 30, 0.75) 0%, rgba(2, 9, 16, 0.88) 100%) !important;\n  backdrop-filter: blur(20px) saturate(180%);\n  -webkit-backdrop-filter: blur(20px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.24) !important;\n  border-radius: 20px;\n  padding: 12px 28px 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.65), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n\n.sp-footer-hdr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.sp-footer-tag {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 2.5px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n}\n\n.sp-footer-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.sp-footer-plain-text {\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: default;\n  letter-spacing: 0.2px;\n  user-select: none;\n}\n\n.sp-footer-legal-divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 20%, rgba(255, 255, 255, 0.12) 80%, transparent 100%);\n  margin: 6px 0 2px;\n}\n\n.sp-footer-legal-row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 4px 6px 2px;\n}\n\n.sp-footer-copyright {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.45);\n  letter-spacing: 0.2px;\n}\n\n.sp-footer-legal-links {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.sp-legal-link {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.65);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.2px;\n}\n\n.sp-legal-link:hover {\n  color: #5eead4;\n  text-shadow: 0 0 8px rgba(94, 234, 212, 0.5);\n}\n\n.sp-legal-separator {\n  color: rgba(255, 255, 255, 0.25);\n  font-size: 8px;\n}\n\n/* RESPONSIVE SCALING */\n@media (max-width: 1200px) {\n  .sp-cards-container {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 10px 24px 20px;\n  }\n  .sp-footer-v2 {\n    margin: 20px 24px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .sp-header {\n    padding: 12px 20px;\n  }\n  .sp-nav {\n    display: none;\n  }\n  .sp-hero-title {\n    padding: 20px 16px 10px;\n  }\n  .sp-hero-capsule {\n    border-radius: 20px;\n    padding: 10px 20px 8px;\n    gap: 4px;\n  }\n  .sp-hero-heading {\n    font-size: 15px;\n    letter-spacing: 1.5px;\n    gap: 8px;\n  }\n  .sp-pillar {\n    letter-spacing: 1.5px;\n  }\n  .sp-hero-subheading {\n    font-size: 10.5px;\n    gap: 6px;\n    letter-spacing: 0.5px;\n  }\n  .sp-cards-container {\n    grid-template-columns: 1fr;\n    padding: 10px 20px 20px;\n    gap: 20px;\n  }\n  .sp-glow-card {\n    padding: 20px;\n  }\n  .sp-footer-v2 {\n    margin: 15px 20px 0;\n    padding: 12px 16px;\n  }\n  .sp-footer-links {\n    gap: 15px 20px;\n  }\n}\n\n@media (max-width: 520px) {\n  .card-body-split {\n    flex-direction: column;\n    align-items: center;\n  }\n  .card-left-column {\n    width: 100%;\n  }\n  .phone-mockup-wrapper {\n    position: relative;\n    right: auto;\n    top: auto;\n    width: 100%;\n    margin-top: 16px;\n  }\n  .phone-mockup {\n    transform: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
